<template>
  <v-container>
    <DataLoader v-if="fetchLoading" :loading="fetchLoading" />
    <template v-else>
      <router-link class="d-block mb-2" to="/admin/settings/html_pages"
        >← HTMLページ一覧に戻る</router-link
      >
      <basic-header />
      <v-row>
        <v-col cols="2">
          <div
            v-for="htmlPageVersion in htmlPage.htmlPageVersions"
            :key="htmlPageVersion.id"
            class="ml-auto"
          >
            <v-card
              v-show="htmlPageVersion.id === selectedHtmlPageVersionId"
              class="grey lighten-5 my-1"
            >
              <div
                v-show="htmlPageVersion.selectedTab"
                class="d-flex flex-column"
              >
                <tab-edit
                  :html-page-version="htmlPageVersion"
                  @not-updated-html-page-version="notUpdatedHtmlPageVersion"
                  @destroy-html-page-version="destroy"
                  @duplicate-html-page-version="duplicateHtmlPageVersion"
                />
              </div>
            </v-card>
            <v-btn
              v-show="htmlPageVersion.id != selectedHtmlPageVersionId"
              height="auto"
              width="100%"
              class="mt-1 py-3 py-0 px-0"
              @click="selectedTab(htmlPageVersion.id)"
            >
              <div style="width: 100%">
                <p
                  v-if="htmlPageVersion.notUpdated"
                  style="font-size: 12px"
                  class="error--text"
                >
                  変更が反映されていません
                </p>
                <div class="d-flex">
                  <p class="pre-wrap ml-auto" v-text="htmlPageVersion.name"></p>
                  <template v-if="htmlPageVersion.deliveryRate === 1">
                    <v-chip
                      class="mr-3 ml-auto font-weight-bold"
                      x-small
                      label
                      color="success"
                    >
                      公開
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip
                      class="mr-3 ml-auto px-1 font-weight-bold"
                      x-small
                      label
                      color="warning"
                    >
                      非公開
                    </v-chip>
                  </template>
                </div>
              </div>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="10">
          <HtmlEditArea
            v-if="htmlPage.id && selectedHtmlPageVersionId"
            :id="selectedHtmlPageVersionId"
            @not-updated-html-page-version="notUpdatedHtmlPageVersion"
          />
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import BasicHeader from './BasicHeader'
import HtmlEditArea from './HtmlEditArea'
import TabEdit from './tabEdit.vue'
import DataLoader from '@/components/commons/DataLoader'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    BasicHeader,
    HtmlEditArea,
    TabEdit,
    DataLoader
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'バージョン編集',
      selectedHtmlPageVersionId: null,
      fetchLoading: true
    }
  },
  computed: {
    ...mapState({
      htmlPage: (state) => state.HtmlPageStore.htmlPage
    })
  },
  async mounted () {
    this.fetchLoading = true
    await this.fetchHtmlPage()
    this.htmlPageVersionDisplayFirst()
    this.fetchLoading = false
  },
  methods: {
    fetchHtmlPage () {
      const query = {
        htmlPageId: this.$route.params.id
      }
      return this.$store.dispatch('fetchHtmlPage', query)
    },
    destroy (htmlPageVersionId) {
      if (this.htmlPage.htmlPageVersions.length > 1) {
        this.$store.dispatch('LoaderStore/displayLoader')
        axios
          .delete(`/api/html_page_versions/${htmlPageVersionId}/`)
          .then(
            () => {
              const payload = {
                status: 200,
                message: 'バージョンを削除しました'
              }
              this.fetchHtmlPage()
              this.selectedHtmlPageVersionId = null
              this.$store.dispatch('SystemMessageStore/createMessage', payload)
            },
            (error) => {
              const payload = {
                status: error.response.status,
                message: error.response.data.message
              }
              this.$store.dispatch('SystemMessageStore/createMessage', payload)
            }
          )
          .finally(() => {
            this.$store.dispatch('LoaderStore/hideLoader')
          })
      } else {
        const payload = {
          status: 500,
          message: 'バージョンは最低一つ必要です'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    },
    duplicateHtmlPageVersion (htmlPageVersionId) {
      this.$store.dispatch('LoaderStore/displayLoader')
      axios
        .post(
          `/api/html_page_versions/${htmlPageVersionId}/duplicate_html_page_version`
        )
        .then(
          () => {
            const payload = {
              status: 200,
              message: 'バージョンを複製しました'
            }
            this.fetchHtmlPage()
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
        .finally(() => {
          this.$store.dispatch('LoaderStore/hideLoader')
        })
    },
    htmlPageVersionDisplayFirst () {
      if (!this.selectedHtmlPageVersionId) {
        var htmlPageVersion = this.htmlPage.htmlPageVersions.find(
          (htmlPageVersion) => htmlPageVersion.deliveryRate === 1
        )
        if (htmlPageVersion) {
          this.selectedHtmlPageVersionId = htmlPageVersion.id
        } else {
          this.selectedHtmlPageVersionId = this.htmlPage.htmlPageVersions[0].id
        }
      }
    },
    selectedTab (selectedVersionId) {
      var htmlPageVersion = this.htmlPage.htmlPageVersions.find(
        (htmlPageVersion) => htmlPageVersion.id === selectedVersionId
      )
      this.selectedHtmlPageVersionId = htmlPageVersion.id
    },
    notUpdatedHtmlPageVersion (htmlPageVersionId) {
      const payload = {
        htmlPageVersionId: htmlPageVersionId
      }
      this.$store.commit('UPDATE_HTML_PAGE_VERSION_NOT_UPDATED', payload)
    }
  }
}
</script>
<style scoped>
.pre-wrap {
  width: 120px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
</style>
